import "./Feedback.module.css";
import NavigationBar from "@/reusable_sections/Header";
import ContactLocalService from "./sections/ContactLocalService";
import ContactInformation from "./sections/ContactInformation";
import FooterInformation from "@/reusable_sections/Footer";
export default function FeedbackPage() {
  return <div>
      <NavigationBar />
      <ContactLocalService />
      <ContactInformation />
      <FooterInformation />
    </div>;
}